export function viberLink(phone) {
  if (!phone) {
    return '#';
  }
  return `viber://contact?number=%2B${String(phone).replace('+', '')}`;
}

/** @param {string} value — @username, t.me URL, or phone number */
export function telegramLink(value) {
  if (!value) {
    return '#';
  }
  const raw = String(value).trim();
  if (/^https?:\/\//i.test(raw)) {
    return raw;
  }
  if (/^t\.me\//i.test(raw)) {
    return `https://${raw}`;
  }
  if (raw.startsWith('@')) {
    return `https://t.me/${raw.slice(1)}`;
  }
  const digits = raw.replace(/\D/g, '');
  if (digits.length >= 8) {
    return `https://t.me/+${digits}`;
  }
  return `https://t.me/${raw}`;
}
